import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { register } from "../services/authApi";

const SignUpLayer = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    brandName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((current) => ({
      ...current,
      [name]: value,
    }));

    setError("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (formData.password.length < 12) {
      setError("Password must be at least 12 characters.");
      return;
    }

    if (formData.password.length > 128) {
      setError("Password must be 128 characters or fewer.");
      return;
    }

    setError("");
    setIsSubmitting(true);

    try {
      await register({
        brandName: formData.brandName.trim(),
        email: formData.email.trim(),
        password: formData.password,
      });

      navigate("/verify-email", {
        state: {
          email: formData.email.trim(),
        },
      });
    } catch (requestError) {
      if (
        requestError.code === "VERIFICATION_EMAIL_DELIVERY_FAILED"
      ) {
        navigate("/verify-email", {
          state: {
            email: formData.email.trim(),
            emailDeliveryFailed: true,
          },
        });

        return;
      }

      setError(
        requestError.message ||
          "We could not create your account. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="simplif-auth-page">
      <header className="simplif-auth-header">
        <Link to="/sign-in" className="simplif-auth-logo">
          <img
            src="/assets/images/simplif/simplif-logo.png"
            alt="Simplif"
          />
        </Link>

        <div className="simplif-auth-header-actions">
          <Link to="/sign-in" className="simplif-auth-login-link">
            Login
          </Link>

          <Link to="/sign-up" className="simplif-auth-signup-button">
            SIGN UP
          </Link>
        </div>
      </header>

      <main className="simplif-auth-main">
        <div className="simplif-auth-card">
          <section className="simplif-auth-form-panel">
            <div className="simplif-auth-form-content">
              <h1>Create Your Account</h1>

              <p className="simplif-auth-subtitle">
                Sign up to start protecting your brand with Simplif
              </p>

              <form onSubmit={handleSubmit}>
                <div className="simplif-auth-field">
                  <label htmlFor="signup-brand-name">
                    Brand Name
                  </label>

                  <input
                    id="signup-brand-name"
                    name="brandName"
                    type="text"
                    placeholder="Brand Name"
                    value={formData.brandName}
                    onChange={handleChange}
                    autoComplete="organization"
                    maxLength={255}
                    required
                  />
                </div>

                <div className="simplif-auth-field">
                  <label htmlFor="signup-email">
                    Email
                  </label>

                  <input
                    id="signup-email"
                    name="email"
                    type="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    autoComplete="email"
                    required
                  />
                </div>

                <div className="simplif-auth-field">
                  <label htmlFor="signup-password">
                    Password
                  </label>

                  <input
                    id="signup-password"
                    name="password"
                    type="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    autoComplete="new-password"
                    minLength={12}
                    maxLength={128}
                    required
                  />
                </div>

                <div className="simplif-auth-field">
                  <label htmlFor="signup-confirm-password">
                    Confirm Password
                  </label>

                  <input
                    id="signup-confirm-password"
                    name="confirmPassword"
                    type="password"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    autoComplete="new-password"
                    minLength={12}
                    maxLength={128}
                    required
                  />
                </div>

                {error && (
                  <p
                    className="simplif-auth-status-message"
                    role="alert"
                  >
                    {error}
                  </p>
                )}

                <button
                  type="submit"
                  className="simplif-auth-primary-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting
                    ? "Creating Account..."
                    : "Sign Up"}
                </button>

                <div className="simplif-auth-bottom-link">
                  Already have an account?{" "}
                  <Link to="/sign-in">
                    Sign in
                  </Link>
                </div>
              </form>
            </div>
          </section>

          <section className="simplif-auth-side-panel">
            <div className="simplif-auth-pattern simplif-auth-pattern-top" />

            <div className="simplif-auth-side-content">
              <h2>Already have an Account?</h2>

              <p>
                Sign in to access your Simplif dashboard.
              </p>

              <Link
                to="/sign-in"
                className="simplif-auth-secondary-button"
              >
                Sign in
              </Link>
            </div>

            <div className="simplif-auth-pattern simplif-auth-pattern-bottom" />
          </section>
        </div>
      </main>
    </div>
  );
};

export default SignUpLayer;
